export default __webpack_public_path__ + "static/media/send-registration-link-icon.ae183bea.svg";